import Vue from 'vue/dist/vue.esm'
import template from './people_multiselect_template.slim'
import withScrollToTop from '../../../mixins/with_scroll_to_top.js'

Vue.component('people-multiselect', {
  mixins: [template, withScrollToTop],
  props: ['value', 'people_options', 'errors', 'required', 'label_text', 'assessor_id'],
  data() {
    return {
      hasFocus: false,
    }
  },
  methods: {
    updatePeople(value) {
      if (this.assessor_id && !value.some(option => option.value === this.assessor_id)) {
        return;
      }
      this.$emit('input', value)
    },
    toggleFocus(e) {
      e.stopPropagation()
      e.preventDefault()
      if (this.hasFocus) {
        $('body').focus()
      } else {
        this.$refs.peopleSelect.$el.focus()
      }
      this.hasFocus = !this.hasFocus
    },
  },
})
